// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8d79469c81b9a7f50c93d1405bf9ceb507bcac5c/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};